import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ProductType, StatusLongTermLease,
} from 'app/enums/label.enums'
import {
    LongTermLeaseTableType,
} from './longTermLease.types'

const config: SkyNetTableConfig<keyof LongTermLeaseTableType> = {
    name: 'OrderManagement.LongTermLeaseTable',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'longTermLeaseNumber',
                reduced: true,
                labelKey: 'LongTermLease.contractNumber',
            },
            {
                name: 'customerExecutionLocationName',
                filterField: 'customerExecutionLocationName',
                filterType: FilterType.Array,
                reduced: true,
                labelKey: 'LongTermLease.customerExecutionCompanyName',
            },
            {
                name: 'customerExecutionContactsContactName',
                componentName: 'List',
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                sorting: false,
            },
            {
                name: 'leaseStartTimestamp',
                componentName: 'DateTimeCell',
            },
            {
                name: 'status',
                filterField: 'status',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: StatusLongTermLease,
            },
        ],
    }],
}

export default config
